import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGalleryImportIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.49984 6.66667C7.23622 6.66667 7.83317 6.06971 7.83317 5.33333C7.83317 4.59695 7.23622 4 6.49984 4C5.76346 4 5.1665 4.59695 5.1665 5.33333C5.1665 6.06971 5.76346 6.66667 6.49984 6.66667Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.16683 1.33203H6.50016C3.16683 1.33203 1.8335 2.66536 1.8335 5.9987V9.9987C1.8335 13.332 3.16683 14.6654 6.50016 14.6654H10.5002C13.8335 14.6654 15.1668 13.332 15.1668 9.9987V6.66536",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5 1.33203V5.33203L13.8333 3.9987",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4998 5.33333L11.1665 4",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.27979 12.635L5.56645 10.4283C6.09312 10.075 6.85312 10.115 7.32645 10.5217L7.54645 10.715C8.06645 11.1617 8.90645 11.1617 9.42645 10.715L12.1998 8.335C12.7198 7.88833 13.5598 7.88833 14.0798 8.335L15.1665 9.26833",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgGalleryImportIcon;
